import Api from './Api'

class ShippingRate extends Api {
  protected resource: string = 'shipping-rates'
}

export default new ShippingRate()
